<ng-container *ngIf="initialize">
  <div class="container isBackgoround" style="padding: 0">
    <header class="header">
      <div style="height: 100%">
        <h1
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            class="logo-image"
            src="/assets/sas-clinic/images/logo.svg"
            width="194"
            height="56px"
            alt="SasClinic"
          />
        </h1>
      </div>
    </header>
    <main>
      <div
        class="text-center mb-6"
        style="
          background: #EDF5F8;
          height: 188px;
          display: flex;
          justify-content: center;
        "
      >
        <img
          src="/assets/sas-clinic/images/checked.svg"
          width="100"
          height="100"
          alt="SasClinic"
        />
      </div>

      <div class="container_min">
        <h2 class="text-h6 font-weight-bold text-center mb-6">
          ロックを解除しました
        </h2>
        <p class="text-caption text-subtitle-1 text-center mb-6">
          あなたのアカウントのロックが解除されました。<br />
          {{ countdown }}秒後に、{{appname}}のトップページへ自動的に移動します。
        </p>
        <p class="text-caption text-center mb-6">
          自動的に移動しない場合は、「トップに戻る」ボタンを押してください。
        </p>

        <div class="mb-6">
          <button (click)="redirect()" class="resetButton font-weight-bold">
            トップに戻る
          </button>
        </div>
      </div>
    </main>
  </div>
</ng-container>
